import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { GraphQLError } from 'graphql';
export var consolidateApolloErrors = function consolidateApolloErrors(error) {
  if (!error) return [];
  var _error$graphQLErrors = error.graphQLErrors,
    graphQLErrors = _error$graphQLErrors === void 0 ? [] : _error$graphQLErrors,
    networkError = error.networkError;
  if (!networkError) return graphQLErrors;
  var networkErrorAsGraphQL = new GraphQLError(networkError.message || 'Network Error', undefined, undefined, undefined, undefined, undefined, {
    code: 'statusCode' in networkError ? "NETWORK_ERROR-".concat(networkError.statusCode) : 'NETWORK_ERROR',
    type: 'SERVER',
    details: {
      reason: networkError.message,
      statusCode: 'statusCode' in networkError ? networkError.statusCode : undefined
    }
  });
  return [].concat(_toConsumableArray(graphQLErrors), [networkErrorAsGraphQL]);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ApolloUtils/consolidateApolloErrors.js
// module id = 4168
// module chunks = 11